function arrayEquals(a: any[], b: any) {
  if (a.length !== b.length)
    return false;
  for (let i = 0; i < a.length; i++)
    if (!deepEquals(a[i], b[i]))
      return false;
  return true;
}

function objectEquals(a: { [key: string]: any }, b: { [key: string]: any }) {
  const keys = Object.keys(a);
  for (let key of keys)
    if (!deepEquals(a[key], b[key]))
      return false;
  return true;
}

// supports only null, undefined, string, boolean, object, array types (recursively)
export function deepEquals(a: any, b: any) {
  if (a === b)
    return true;

  if (typeof a !== typeof b)
    return false;
  if (Object.is(a, b))
    return true;

  if (a && b && typeof a === 'object') {
    if (Array.isArray(a) && Array.isArray(b))
      return arrayEquals(a, b);

    if (Array.isArray(a) || Array.isArray(b))
      return false;

    return objectEquals(a, b);
  }
  return false;
}
